import * as Header from '-/Custom/Header';
import { useRouter } from 'expo-router';
import Menu from '@/components/UI/Menu';
import Icon from '@/components/Unistyles/Icon';

export default function ChatCreateMenu() {
  const { push } = useRouter();

  return (
    <Menu
      title="New Chat"
      actions={[
        {
          id: 'createDirectChat',
          title: 'Direct Message',
          icon: 'chatbubble-outline',
          onSelect: () => {
            push({
              pathname: '/chat/create/direct',
            });
          },
        },
        {
          id: 'createGroupChat',
          title: 'Group Chat',
          icon: 'chatbubbles-outline',
          onSelect: () => {
            push({
              pathname: '/chat/create/group',
            });
          },
        },
      ]}
    >
      {(triggerProps) => (
        <Header.Button
          {...triggerProps}
          accessibilityLabel="Create chat"
          testID="ChatHomeCreateMenuButton"
        >
          <Icon name="add-outline" size="3xl" />
        </Header.Button>
      )}
    </Menu>
  );
}
